import {FormConfig} from "../../form/form.config";
import {WarmwassercheckAnfrage} from "../anfrage/warmwassercheck.anfrage";
import {StepComponent} from "../../step/step.component";
import {FormModel} from "../../form/form.model.abstract";
import {FormModelRadio} from "../../form/form.model.radio";
import {FormGroup, ValidatorFn, Validators} from "@angular/forms";
import {FormModelText} from "../../form/form.model.text";
import {ValidationService} from "../../services/validation.service";
import {FormModelNumber} from "../../form/form.model.number";
import {FormModelTextSelect} from "../../form/form.model.textselect";
import {WarmwassercheckConstants} from "../warmwassercheck.constants";
import {FormModelHidden} from "../../form/form.model.hidden";
import {FormModelCombine} from "../../form/form.model.combine";
import {FormModelDoubleTextSelect} from "../../form/form.model.doubletext-select";


export class EingabeForm extends FormConfig {
  /**
   * some data is needed here for validation
   */
  public anfrage: WarmwassercheckAnfrage;

  /**
   * (input) data of the user
   */
  stepComponent: StepComponent;

  /**
   * @inheritDoc
   * @protected
   *
   */
  protected fields: FormModel[] = [
    //basisinformationen
    new FormModelRadio('nutzungstyp', ['hauseigentuemer', 'wohnungseigentuemer', 'hausverwalter', 'mieter'], [Validators.required], null, null, false),
    new FormModelRadio('gebaeudetyp', ['1-2familienhaus', 'mehrfamilienhaus'], [Validators.required], null, null, false),
    (new FormModelText('postleitzahl', [Validators.required, ValidationService.postalCode], null, null, true)).setClasses('small-field'),
    new FormModelHidden('ort'),
    new FormModelNumber('bewohneranzahl', [Validators.required, Validators.min(1), Validators.max(WarmwassercheckConstants.FORM_PEOPLE_MAX), ValidationService.allowIntegerOnly],  null, WarmwassercheckConstants.FORM_PEOPLE_DEFAULT, false),

    // verbrauchsdaten
    new FormModelRadio('warmwasser_bereitungstyp', ['gebaeudezentral', 'dezentral'], [Validators.required], null, null, true),
    (new FormModelRadio('energietraeger', ['erdgas', 'heizoel', 'fernwaerme', 'fluessiggas', 'holzpellets', 'waermepumpe', 'waermepumpe_luft', 'waermepumpe_wasser'], [Validators.required], null, null, false)),
    (new FormModelRadio('warmwasser_verbrauch_bekannt', ['ja', 'nein'], [Validators.required], null, null, false)),

    (new FormModelTextSelect('warmwasser_verbrauch', 'warmwasser_einheit', [Validators.required, Validators.min(1)],  ['m3', 'liter'], [], false, 'number')),

    (new FormModelDoubleTextSelect('duschen_anzahl_1', 'duschen_dauer_1', 'duschen_zeiteinheit_1', 'anzahl', 'minuten', [Validators.required, Validators.min(1)], ['tag', 'woche', 'monat'], [], false, 'number')).setInactive(),
    (new FormModelDoubleTextSelect('duschen_anzahl_2', 'duschen_dauer_2', 'duschen_zeiteinheit_2', 'anzahl', 'minuten', [], ['tag', 'woche', 'monat'], [], false, 'number')).setInactive(),
    (new FormModelDoubleTextSelect('duschen_anzahl_3', 'duschen_dauer_3', 'duschen_zeiteinheit_3', 'anzahl', 'minuten', [], ['tag', 'woche', 'monat'], [], false, 'number')).setInactive(),
    (new FormModelDoubleTextSelect('duschen_anzahl_4', 'duschen_dauer_4', 'duschen_zeiteinheit_4', 'anzahl', 'minuten', [], ['tag', 'woche', 'monat'], [], false, 'number')).setInactive(),
    (new FormModelDoubleTextSelect('duschen_anzahl_5', 'duschen_dauer_5', 'duschen_zeiteinheit_5', 'anzahl', 'minuten', [], ['tag', 'woche', 'monat'], [], false, 'number')).setInactive(),

    (new FormModelRadio('sparduschkopf_vorhanden', ['ja', 'nein', 'unbekannt'], [Validators.required], null, null, false)),

    (new FormModelTextSelect('baden_anzahl', 'baden_zeiteinheit', [],  ['woche', 'monat', 'quartal', 'jahr'], [], false, 'number')),

    (new FormModelCombine('geschirrspuelen_anzahl', [
      new FormModelTextSelect('geschirrspuelen_anzahl_wenig', 'geschirrspuelen_zeiteinheit_wenig', [],['tag', 'woche'],[], false, 'number'),
      new FormModelTextSelect('geschirrspuelen_anzahl_normal', 'geschirrspuelen_zeiteinheit_normal', [],['tag', 'woche'],[], false, 'number')
    ])).setInactive(),
    // warmwasserbereitung
    (new FormModelRadio('versorgung_technik', ['zentralheizung_mit_zirkulation', 'zentralheizung_ohne_zirkulation'], [Validators.required], null, null, false)).setInactive(),
    (new FormModelRadio('versorgung_geraet', [], [Validators.required], null, null, false)).setInactive(),
    (new FormModelText('speichervolumen', [Validators.required], 'liter', null, false, 'number')).setInactive(),

    // geraetedaten
    (new FormModelText('ww_geraet_baujahr', [Validators.required, ValidationService.minBuildingYear(WarmwassercheckConstants.VALIDATE_WW_GERAET_BAUJAHR)], null, null, false, 'number')).setInactive(),
    new FormModelText('warmwasser_temperatur', [Validators.required, Validators.min(WarmwassercheckConstants.VALIDATE_TEMPERATURE_MIN), Validators.max(WarmwassercheckConstants.VALIDATE_TEMPERATURE_MAX)], 'deg', 60, false, 'number'),
    (new FormModelRadio('waermemengenzaehler_vorhanden', ['ja', 'nein', 'unbekannt'], [Validators.required], null, null, false)).setInactive(),
    (new FormModelText('ww_energieverbrauch', [Validators.required, Validators.min(WarmwassercheckConstants.VALIDATE_WW_ENERGIEVERBRAUCH_MIN), Validators.max(WarmwassercheckConstants.VALIDATE_WW_ENERGIEVERBRAUCH_MAX)], 'kwha', null, false, 'number')).setInactive(),


  ];

  protected groups: any = {
    'basisdaten/1': ['nutzungstyp'],
    'basisdaten/2': ['gebaeudetyp'],
    'basisdaten/3': ['postleitzahl', 'ort'],
    'basisdaten/4': ['bewohneranzahl'],

    'verbrauchsdaten/1': ['warmwasser_bereitungstyp'],
    'verbrauchsdaten/2': ['energietraeger'],
    'verbrauchsdaten/3': ['warmwasser_verbrauch_bekannt'],
    'verbrauchsdaten/4': ['warmwasser_verbrauch'],
    'verbrauchsdaten/5': ['duschen_anzahl_1', 'duschen_anzahl_2', 'duschen_anzahl_3', 'duschen_anzahl_4', 'duschen_anzahl_5'],
    'verbrauchsdaten/6': ['sparduschkopf_vorhanden'],
    'verbrauchsdaten/7': ['baden_anzahl'],
    'verbrauchsdaten/8': ['geschirrspuelen_anzahl'],

    'wasserbereitung/1': ['versorgung_technik'],
    'wasserbereitung/2': ['versorgung_geraet', 'speichervolumen'],

    'geraetedaten/1': ['ww_geraet_baujahr'],
    'geraetedaten/2': ['warmwasser_temperatur'],
    'geraetedaten/3': ['waermemengenzaehler_vorhanden', 'ww_energieverbrauch'],
  };

  /**
   * The options for some fields that are dynamic, depending on other form fields
   */
  static readonly options: any = {
    'warmwasser_bereitungstyp': {
      '1-2familienhaus': ['gebaeudezentral', 'dezentral'],
      'mehrfamilienhaus': ['gebaeudezentral', 'dezentral', 'wohnungszentral'],
    },
    'energietraeger': {
      'mieter': ['erdgas', 'heizoel', 'fernwaerme', 'fluessiggas', 'holzpellets', 'waermepumpe', 'waermepumpe_luft', 'waermepumpe_wasser', 'unbekannt'],
      'wohnungseigentuemer': ['erdgas', 'heizoel', 'fernwaerme', 'fluessiggas', 'holzpellets', 'waermepumpe', 'waermepumpe_luft', 'waermepumpe_wasser', 'unbekannt'],
      'hauseigentuemer': ['erdgas', 'heizoel', 'fernwaerme', 'fluessiggas', 'holzpellets', 'waermepumpe', 'waermepumpe_luft', 'waermepumpe_wasser'],
      'hausverwalter': [],
    },
    'versorgung_technik': {
      'gebaeudezentral': ['zentralheizung_mit_zirkulation', 'zentralheizung_ohne_zirkulation'],
      'dezentral': ['strom_durchlauferhitzer', 'strom_boiler'],
    },
    'versorgung_geraet': {
      'zentralheizung_mit_zirkulation': ['mit_solarthermie', 'ohne_solarthermie'],
      'zentralheizung_ohne_zirkulation': ['mit_speicher', 'ohne_speicher', 'mit_solarthermie_und_speicher'],
      'strom_durchlauferhitzer': ['elektronisch', 'vollelektronisch', 'hydraulisch'],
      'strom_boiler': ['kleinspeicher', 'wandspeicher', 'standspeicher'],
    }

  };

  /**
   * Validator for the maximum value of all dynamic fields duschen_anzahl depeding on people count
   * @param formConfig
   */
  static countAndDurationMaxShower(formConfig: EingabeForm): ValidatorFn {
    return(formGroup: FormGroup) => {
        if(formConfig.anfrage) {
          // get the people count from user input
          const people = formConfig.anfrage.userInput?.bewohneranzahl;

          // check as many duschen_dauer fields as people
          for (let i = 1; i <= people; i++) {
            const showerCount = 'duschen_anzahl_' + i;
            const timeUnit = 'duschen_zeiteinheit_' + i;
            const duration = 'duschen_dauer_' + i;

            // get the values to dusch_anzahl and duschen_zeiteinheit of each field
            if (formGroup?.controls[showerCount]?.value > 0) {
              const valueShowerCount = formGroup.controls[showerCount].value;
              const valueTimeUnit = formGroup?.controls[timeUnit]?.value;

              // duschen_anzahl
              if (valueTimeUnit) {
                // return error if the value of each field duschen_anzahl is higher than max value
                if (valueShowerCount > WarmwassercheckConstants['VALIDATE_DUSCHEN_ANZAHL_MAX_' + valueTimeUnit.toUpperCase()]) {
                  return { countMaxShower: false };
                }
              }
            }

            // duschen_dauer
            if (formGroup?.controls[duration]?.value > 0) {
              const valueShowerDuration = formGroup.controls[duration].value;

              // return error if the value of each field duschen_dauer is higher than max value
              if (valueShowerDuration > WarmwassercheckConstants.FORM_SHOWER_DURATION_MAX) {
                return { durationMaxShower: false };
              }
            }
          }
        }
      return null;
    };
  }

  /**
   * Validator for the maximum value of field baden_anzahl
   * @param formConfig
   */
  static countMaxBath(formConfig: EingabeForm): ValidatorFn {
    return(formGroup: FormGroup) => {
        // validate the current field
        if(formGroup?.controls['baden_anzahl']?.value > 0 && formConfig.anfrage) {
          const valueBathCount = formGroup.controls['baden_anzahl'].value;
          const valueTimeUnit = formGroup?.controls['baden_zeiteinheit']?.value;

          // check which value we have in 'zeiteinheit we have
            if(valueTimeUnit) {
              // get the right maximum values from contants
              const validateMaxPerson = WarmwassercheckConstants['VALIDATE_BADEN_ANZAHL_MAX_' + valueTimeUnit.toUpperCase()];
              const validationMax = validateMaxPerson * formConfig.anfrage.userInput?.bewohneranzahl;

              if(valueBathCount > validationMax) {
                return {countMaxBath: false};
              }
            }
          }
      return null;
    };
  }

  /**
   * Validator for the maximum value of field geschirrspuelen_anzahl_wenig and geschirrspuelen_anzahl_normal
   * @param formConfig
   */
  static countMaxDishes(formConfig: EingabeForm): ValidatorFn {
    return(formGroup: FormGroup) => {
      if (formConfig.anfrage &&
        (formGroup?.controls['geschirrspuelen_anzahl_wenig']?.value > 0 || formGroup?.controls['geschirrspuelen_anzahl_normal']?.value > 0)) {
        // check first in which input field we have a value
        for (const postfix of WarmwassercheckConstants.POSTFIX_GESCHIRRSPUELEN) {
          const dishesCount = 'geschirrspuelen_anzahl' + postfix;
          const timeUnit = 'geschirrspuelen_zeiteinheit' + postfix;

          // validate the current field
          const valueDishesCount = formGroup.controls[dishesCount].value;
          const valueTimeUnit = formGroup?.controls[timeUnit]?.value;

          // check which value we have in 'zeiteinheit we have
          if (valueTimeUnit) {
            // get the right maximum values from contants depending on zeiteinheit value
            const validateMaxPerson = WarmwassercheckConstants['VALIDATE_GESCHIRRSPUELEN_ANZAHL_MAX_' + valueTimeUnit.toUpperCase()];
            const validationMax = validateMaxPerson * formConfig.anfrage.userInput?.bewohneranzahl;
            if (valueDishesCount > validationMax) {
              return {countMaxDishes: false};
            }
          }
        }
      }
      return null;
    };
  }





  /**
   * Validats field water consumption for a minimum and maximum. Returns an error if the consumption is outside the min/max range.
   * @param formConfig
   */
  static consumptionMinMax(formConfig: EingabeForm): ValidatorFn {
    return (formGroup: FormGroup) => {
      if(formGroup?.controls['warmwasser_verbrauch']?.value && formConfig.anfrage) {
        // get the values 'warmwasser_verbrauch' and 'warmwasser_einheit' from forminput
        let consumption = formGroup?.controls['warmwasser_verbrauch']?.value;
        const unit = formGroup?.controls['warmwasser_einheit']?.value;

        if(formConfig.anfrage.userInput?.bewohneranzahl) {
          // get the value people from input
          const people = formConfig.anfrage.userInput.bewohneranzahl;

          // define min/max consumption depending on unit
          const minConsumption =
            unit === 'liter' ?
              WarmwassercheckConstants.VALIDATE_CONSUMPTION_MIN * people :
              WarmwassercheckConstants.VALIDATE_CONSUMPTION_MIN * people/ 1000;
          const maxConsumption =
            unit === 'liter' ?
              WarmwassercheckConstants.VALIDATE_CONSUMPTION_MAX * people :
              WarmwassercheckConstants.VALIDATE_CONSUMPTION_MAX * people / 1000;

          // convert value consumption into float number if value is a comma separated string
          consumption = ValidationService.parseStringToFloat(consumption);

          // show different error message for min or max
          if (consumption < minConsumption) {
            return {consumptionMin: false};
          }
          if (consumption > maxConsumption) {
            return {consumptionMax: false};
          }
        }
      }
      return null;
    }
  }

  /**
   * Validats field storage volume 'speichervolumen' for a minimum and maximum. Returns an error if the storage volume is outside the min/max range.
   * @param formConfig
   */
  static storageMinMax(formConfig: EingabeForm): ValidatorFn {
    return (formGroup: FormGroup) => {
      if(formGroup?.controls['versorgung_geraet']?.value && formConfig.anfrage?.userInput?.versorgung_technik === 'strom_boiler') {
        // get value 'warmwasser_bereitung_elektrospeicher' from form input
        const storageType = formGroup?.controls['versorgung_geraet']?.value;
        const validateMin = WarmwassercheckConstants['VALIDATE_' + storageType.toUpperCase() + '_MIN'];
        const validateMax = WarmwassercheckConstants['VALIDATE_' + storageType.toUpperCase() + '_MAX'];

        if(formGroup?.controls['speichervolumen']?.value) {
          const storageValue = formGroup?.controls['speichervolumen']?.value;

          if(storageValue < validateMin) {
            const typeMin = storageType + 'Min';
            return {[typeMin]: false};
          }
          if(storageValue > validateMax) {
            const typeMax = storageType + 'Max';
            return {[typeMax]: false};
          }
        }
      }
      return null;
    }
  }


  /**
   * List of formfields where changes of the value, change other fields.
   */
  fieldsForFormChanges: string[] = ['nutzungstyp', 'gebaeudetyp', 'warmwasser_verbrauch_bekannt', 'warmwasser_bereitungstyp', 'energietraeger', 'bewohneranzahl', 'versorgung_technik', 'versorgung_geraet', 'waermemengenzaehler_vorhanden', 'ww_energieverbrauch'];

  /**
   * List of validators for the whole form. Can be used to validate between fields.
   * @protected
   */
  protected formValidators: ValidatorFn[] = [
    EingabeForm.countAndDurationMaxShower(this),
    EingabeForm.countMaxBath(this),
    EingabeForm.countMaxDishes(this),
    EingabeForm.consumptionMinMax(this),
    EingabeForm.storageMinMax(this)
  ];

  /**
   * List of formvalidators and which fields should be marked as invalid
   * @protected
   */
  protected formValidatorsFields: {[key: string]: string[]} = {
    countMaxShower: ['duschen_anzahl_1', 'duschen_anzahl_2', 'duschen_anzahl_3', 'duschen_anzahl_4', 'duschen_anzahl_5'],
    countMaxBath: ['baden_anzahl'],
    countMaxDishes: ['geschirrspuelen_anzahl'],
    consumptionMinMax: ['warmwasser_verbrauch'],
    storageMinMax: ['speichervolumen']};


  /**
   * Sets stepComponent
   * @param stepComponent
   */
  setStepComponent(stepComponent: StepComponent): void {
    this.stepComponent = stepComponent;
  }

  /**
   * HOlds the last set data
   */
  lastData: {[key: string]: any} = {};

  /**
   * Any time a field is updated, this method is called.
   * @param values
   */
  updateFields(values: {[key: string]: any}): void {
    // remember the last data that we set on this form
    this.lastData = {...this.lastData, ...values};

    // changes based on fields 'nutzungstyp' + 'gebaeudetyp'
    if (values.hasOwnProperty('nutzungstyp') && values.hasOwnProperty('gebaeudetyp')) {
      // first input section: set right options for 'warmwasser_bereitungstyp'
      this.setOptions('warmwasser_bereitungstyp', EingabeForm.options.warmwasser_bereitungstyp[values.gebaeudetyp]);

      // changes based on field 'warmwasser_bereitungstyp'
      if (values.hasOwnProperty('warmwasser_bereitungstyp')) {
        // reset value of field 'warmwasser_bereitungstyp' if not listed in displayed options
        if (EingabeForm.options.warmwasser_bereitungstyp[values.gebaeudetyp].indexOf(values.warmwasser_bereitungstyp) === -1) {
          values.warmwasser_bereitungstyp = null;
        }
        // de/activate fields if 'warmwasser_bereitungstyp' is not null
        if (values.warmwasser_bereitungstyp !== null) {
          // wohnungszentral: deactivate fields 'versorgung_technik' and 'versorgung_geraet'
          if (values.warmwasser_bereitungstyp === WarmwassercheckConstants.WARMWASSER_BEREITUNGSTYP_WOHNUNGSZENTRAL) {
            this.deactivateField('versorgung_technik');
            this.deactivateField('versorgung_geraet');
            values.versorgung_technik = 'erdgas_etagenheizung';
            values.versorgung_geraet = 'therme';
          }
          // gebauedezentral + dezentral: activate fields 'versorgung_technik' and 'versorgung_geraet'
          else {
            this.activateField('versorgung_technik');
            this.setOptions('versorgung_technik', EingabeForm.options.versorgung_technik[values.warmwasser_bereitungstyp]);

            if (values.hasOwnProperty('versorgung_technik')) {
              // reset value of field 'versorgung_technik' if not listed in displayed options
              if (EingabeForm.options.versorgung_technik[values.warmwasser_bereitungstyp].indexOf(values.versorgung_technik) === -1) {
                values.versorgung_technik = null;
                values.versorgung_geraet = null;
              }
              // activate field 'versorgung_geraet' and set right options if 'versorgung_technik' is not null
              if (values.versorgung_technik !== null) {
                this.activateField('versorgung_geraet');
                this.setOptions('versorgung_geraet', EingabeForm.options.versorgung_geraet[values.versorgung_technik]);

                // reset value of field 'versorgung_geraet' if not listed in displayed options
                if (values.hasOwnProperty('versorgung_geraet') && EingabeForm.options.versorgung_geraet[values.versorgung_technik].indexOf(values.versorgung_geraet) === -1) {
                  values.versorgung_geraet = null;
                }

                // changes based on 'strom_boiler'
                if (values.versorgung_technik === 'strom_boiler') {
                  this.activateField('speichervolumen');
                } else {
                  this.deactivateField('speichervolumen');
                  values.speichervolumen = null;
                }
              }
            }
          }

          // warmwasser_bereitungstyp: gebaeudezentral
          if (values.warmwasser_bereitungstyp === WarmwassercheckConstants.WARMWASSER_BEREITUNGSTYP_GEBAEUDEZENTRAL) {
            // activate 'energietraeger' and set right options
            this.activateField('energietraeger');
            this.setOptions('energietraeger', EingabeForm.options.energietraeger[values.nutzungstyp]);
            //activate 'waermemengenzaehler_vorhanden'
            this.activateField('waermemengenzaehler_vorhanden');
            // deactivate 'ww_geraet_baujahr'
            this.deactivateField('ww_geraet_baujahr');

            // mieter/wohnungseigentuemer in mfh, gebaeudezentral: deactivate and reset all fields of section wasserbereitung and geraetedaten
            if (values.gebaeudetyp === WarmwassercheckConstants.GEBAEUDETYP_MFH &&
              (values.nutzungstyp === WarmwassercheckConstants.NUTZUNGSTYP_MIETER || values.nutzungstyp === WarmwassercheckConstants.NUTZUNGSTYP_WOHNUNGSEIGENTUEMER)) {
              for (const field of WarmwassercheckConstants.ALL_FIELDS_WW_BEREITUNG_GERAETEDATEN) {
                this.deactivateField(field);
                values[field] = null;
              }
            }
          }
          else {
            // in all other cases deactivate field 'energietraeger' and 'waermemengenzaehler_vorhanden'
            this.deactivateField('energietraeger');
            values.energietraeger = null;
            this.deactivateField('waermemengenzaehler_vorhanden');
            values.waermemengenzaehler_vorhanden = null;
            values.ww_energieverbrauch = null;
            // activate 'ww_geraet_baujahr'
            this.activateField('ww_geraet_baujahr');
          }

          // warmwasser_bereitungstyp: wohnungszentral
          if (values.warmwasser_bereitungstyp === WarmwassercheckConstants.WARMWASSER_BEREITUNGSTYP_WOHNUNGSZENTRAL) {
            // set energietraeger to 'erdgas'
            values.energietraeger = 'erdgas';
          }

          // warmwasser_bereitungstyp: dezentral
          if (values.warmwasser_bereitungstyp === WarmwassercheckConstants.WARMWASSER_BEREITUNGSTYP_DEZENTRAL) {
            // set energietraeger to 'strom'
            values.energietraeger = 'strom';
          }
          // reset energietraeger if recent value is not in options
          if (values.hasOwnProperty('energietraeger') &&
            this.getField('energietraeger').getOptions().indexOf(values.energietraeger) === -1 &&
            values.warmwasser_bereitungstyp !== WarmwassercheckConstants.WARMWASSER_BEREITUNGSTYP_DEZENTRAL) {
            values.energietraeger = null;
          }

          // reset energietraeger from erdgas if value wohnungszentral changes on current step
          if (values.energietraeger === 'erdgas' &&
            values.warmwasser_bereitungstyp !== WarmwassercheckConstants.WARMWASSER_BEREITUNGSTYP_WOHNUNGSZENTRAL &&
            this.stepComponent?.steps?.currentStep?.name === WarmwassercheckConstants.FIRST_STEP_OF_VERBRAUCHSDATEN) {
            values.energietraeger = null;
          }
        }
      }
    }

    // changes based on field 'nutzungstyp'
    if(values.hasOwnProperty('nutzungstyp')) {
      if (values.nutzungstyp === WarmwassercheckConstants.NUTZUNGSTYP_WOHNUNGSEIGENTUEMER) {
        // hide field gebaeudetyp
        values.gebaeudetyp = WarmwassercheckConstants.GEBAEUDETYP_MFH;
        this.deactivateField('gebaeudetyp');
      }
      else {
        this.activateField('gebaeudetyp');
      }
    }

    // changes based on field 'bewohneranzahl'
    if (values.hasOwnProperty('bewohneranzahl')) {
      const people = this.anfrage?.userInput?.bewohneranzahl;

      // changes based on field 'warmwasser_verbrauch_bekannt'
      if (values.hasOwnProperty('warmwasser_verbrauch_bekannt')) {
        if (values.warmwasser_verbrauch_bekannt === 'ja') {
          // case 1: show field 'warmwasser_verbrauch'
          this.activateField('warmwasser_verbrauch');
          // case 1: hide all other fields in section 'verbrauchsdaten'
          if (values.bewohneranzahl >= 1) {
            // hide all shower fields
              for (let i = 1; i <= people; i++) {
                const fieldCount = 'duschen_anzahl_' + i;
                const fieldDuration = 'duschen_dauer_' + i;
                const fieldTimeUnit = 'duschen_zeiteinheit_' + i;
                // reset values of shower fields
                this.deactivateField(fieldCount);
                values[fieldCount] = null;
                values[fieldDuration] = null;
                values[fieldTimeUnit] = null;
              }

            }

          this.deactivateField('baden_anzahl');
          this.deactivateField('geschirrspuelen_anzahl');
          this.deactivateField('sparduschkopf_vorhanden');

          // reset values
          values.baden_anzahl = null;
          values.baden_zeiteinheit = null;
          values.geschirrspuelen_anzahl_wenig = null;
          values.geschirrspuelen_anzahl_normal = null;
          values.geschirrspuelen_zeiteinheit_wenig = null;
          values.geschirrspuelen_zeiteinheit_normal = null;
          values.sparduschkopf_vorhanden = null;
        }
        else {
          // case 2: hide field 'warmwasser_verbrauch'
          this.deactivateField('warmwasser_verbrauch');
          // case 2: show all other fields in section 'verbrauchsdaten'
          if (values.bewohneranzahl >= 1) {
            // show shower fields based on count people
            for (let i = 1; i <= people; i++) {
              const fieldCount = 'duschen_anzahl_' + (i);
              this.activateField(fieldCount);
            }

            // reset all other not shown duschen fields
            for (let i = people + 1; i <= WarmwassercheckConstants.FORM_PEOPLE_MAX; i++) {
              const fieldCount = 'duschen_anzahl_' + (i);
              const fieldDuration = 'duschen_dauer_' + (i);
              const fieldTimeUnit = 'duschen_zeiteinheit_' + (i);

              // reset values for shower fields
              this.deactivateField(fieldCount);
              values[fieldCount] = null;
              values[fieldDuration] = null;
              values[fieldTimeUnit] = null;
            }
          }

          this.activateField('baden_anzahl');
          this.activateField('geschirrspuelen_anzahl');
          this.activateField('sparduschkopf_vorhanden');

          // reset value
          values.warmwasser_verbrauch = null;
          values.warmwasser_einheit = null;
        }
      }
    }

    // changes based on field 'waermemengenzaehler_vorhanden'
    if (values.hasOwnProperty('waermemengenzaehler_vorhanden')) {
      if (values.waermemengenzaehler_vorhanden === 'ja') {
        this.activateField('ww_energieverbrauch');
      }
      else {
        this.deactivateField('ww_energieverbrauch');
        values.ww_energieverbrauch = null;

        // if 'unbekannt' set value to 'nein'
        if (values.waermemengenzaehler_vorhanden === 'unbekannt') {
          values.waermemengenzaehler_vorhanden = 'nein';
        }
      }
    }

  }

  /**
   * In this function all dynamic changes of the form is done. Based on selection options or value other fields are shown/hidden, options changed and validators adapted.
   *
   * @inheritDoc
   * @param values
   * @protected
   */
  protected onSetData(values: {[key: string]: any}): void {
    this.updateFields(values);
  }

  /**
   * @inheritDoc
   * @protected
   */
  protected onChange() {
    // check if the form has some fields which value changes other fields.
    if(this.fieldsForFormChanges.find(field => this.form.get(field)) != undefined) {
      this.updateFields(this.getData());
    }
  }

  /**
   * @inheritDoc
   * @param step
   * @param id
   */
  getLabel(step: string, id: string): string {
    step = 'warmwassercheck';
    // overwrite labelkey for field 'versorgung_technik'
    if(id === 'versorgung_technik' && this.lastData?.hasOwnProperty('warmwasser_bereitungstyp')) {
      return super.getLabel(step, id) + '.' + this.lastData.warmwasser_bereitungstyp;
    }
    // overwrite labelkey for field 'versorgung_geraet'
    if(id === 'versorgung_geraet' && this.lastData?.hasOwnProperty('versorgung_technik')) {
      return super.getLabel(step, id) + '.' + this.lastData.versorgung_technik;
    }

    return super.getLabel(step, id);
  }

}
